import React, { Fragment, Component } from 'react';
import { withRouter } from 'react-router';
import { withSnackbar } from 'notistack';
import moment from 'moment';
import { Button, Grid, TextField, CircularProgress, Tooltip, Drawer } from '@material-ui/core';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { LabelValueCard, RevisionHistory, PageLoader } from '../../../../shared_elements';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { fieldDateFormat, backendDateFormat, displayDateFormatShort } from '../../../../constants';
import { capitalizeFirstLetter, checkApiStatus, checkPermission } from '../../../../utils_v2';
import { fieldValidation, dateRangeValidation } from '../../../../utils_v2/formValidation';
import { addEditNotesApi, getNotesApi } from '../apiServices';
import { addNotes, errorCode } from '..';
class NotesCRU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      formSubmitLoader: false,
      pageLoader: false,
      mode: '',
      notes: {},
      error: {},
      previewDocs: '',
      deleteItem: null,
      showFullText: { description: false, remarks: false }
    }
    this.addEditNotesApi = addEditNotesApi.bind(this);
    this.getNotesApi = getNotesApi.bind(this);
  }
  onFieldChange = (event, keyParam, data) => {
    this.setState(prevState => ({
      ...prevState,
      notes: {
        ...prevState.notes,
        [keyParam]: data
      }
    }))
  }
  updateErrorField = (key, message) => {
    this.setState(prevState => ({
      ...prevState,
      error: {
        ...prevState.error,
        [key]: message
      }
    }))
  }

  toggleFnc = (key, status) => {
    this.setState({ [key]: status })
  }

  toggleTextExpand = (field) => {
    this.setState((prevState) => ({
      showFullText: {
        ...prevState.showFullText,
        [field]: !prevState.showFullText[field]
      }
    }));
  };

  addEditNotesFn = () => {
    const { notes } = this.state;

    let validationInputs = {
      description: errorCode['description'][fieldValidation({ ...errorCode['descriptionObj'], fieldval: notes.description })],
    };
    // if(notes.start_date && notes.end_date){
    //   validationInputs = {
    //     ...validationInputs,
    //     start_date: dateRangeValidation(notes.start_date, notes.end_date, 30)
    //   }
    // }
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
      this.setState({ formSubmitLoader: true });
      this.addEditNotesApi(this.props, notes)
        .then(response => {
          this.setState({ formSubmitLoader: false });
          if (checkApiStatus(response)) {
            this.props.getResponseBack();
            this.props.enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            this.setState({ modal: false, mode: '', notes: {}, error: {} })
          } else {
            this.props.enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
          }
        })
    } else {
      this.setState({ error: validationInputs });
    }
  }
  previewDoc(item) {
    this.setState({ previewDocs: item })
  }
  handleDelete = (item) => {
    this.setState({ deleteAttachmentModal: true, deleteItem: item });
  };
  getDeleteResponse = () => {
    const { notes, deleteItem } = this.state
    const updatedAttachments = notes?.attachments?.filter(
      attachment => attachment.uuid !== deleteItem?.uuid
    );
    this.setState(prevState => ({
      ...prevState,
      notes: {
        ...prevState.notes,
        attachments: updatedAttachments
      }
    }))
    this.props.getResponseBack()
  }
  render() {
    const { modal, formSubmitLoader, mode, notes, error, pageLoader, showFullRemarks } = this.state;
    const { id, m, contractInfo } = this.props;
    return (
      <Fragment>
        {pageLoader ? <PageLoader /> : null}
        {id ?
          <span onClick={() => this.getNotesApi(this.props, id, m)}><Tooltip title="View"><VisibilityIcon color='primary' fontSize='small' style={{ cursor: 'pointer' }} /></Tooltip></span> :
          contractInfo?.hdlineInfo?.archived_asset == false ?
            <Button onClick={() => this.setState({ modal: true, notes: addNotes, mode: 'add' })} variant="contained" color="primary"><AddIcon style={{fontSize: '1.15rem'}} />Add Notes</Button>
            : null
        }
        {modal ?
          <Drawer
            open={modal}
            anchor="right"
            onClose={() => this.setState({ modal: false, mode: '', notes: {}, error: {} })}
          >
            <div style={{ width: '670px' }} className="drawer-container">
              <div className="drawer-header" alignItems='center'>
                <span className="left-blk">{`${capitalizeFirstLetter(mode)} Notes`}</span>
                <CloseIcon className="close-icon" onClick={() => this.setState({ modal: false })} />
                {mode !== 'add' ?
                  <ul className="list-inline right-blk">
                    <li className="list-inline-item">
                      <RevisionHistory
                        url='audit/contracts/ctnotes/'
                        queryParams={{ action: 1, object_id: id }}
                        buttonType={false}
                      />
                    </li>
                    <li className="list-inline-item">
                      {contractInfo?.hdlineInfo?.archived_asset == false ? checkPermission('contracts', 'lease_notes', 'U') && mode === 'view' && <span className="cta" onClick={() => this.setState({ mode: 'edit' })}><EditIcon className="edit-icon" />Edit</span> : false}
                      {mode !== 'view' && <span className="cta" onClick={() => this.setState({ mode: 'view' })}><VisibilityIcon className="view-icon" />View</span>}
                    </li>
                  </ul> : null
                }
              </div>
              <div className="drawer-body" style={{ position: "sticky" }}>
                <Grid container spacing={3}>
                  {mode === 'view' ?
                    <LabelValueCard md={12} label='Type' value={notes.type ? notes.type : '--'} /> :
                    <Grid item xs={12}>
                      <TextField
                        // required
                        id="type"
                        label="Type"
                        fullWidth
                        margin="normal"
                        value={notes.type ? notes.type : ''}
                        InputLabelProps={{ shrink: true }}
                        error={error.type ? true : false}
                        helperText={error.type ? error.type : ''}
                        onChange={(e) => this.onFieldChange(e, 'type', e.target.value)}
                        onFocus={(e) => this.updateErrorField('type', '')}
                      />
                    </Grid>
                  }
                  {mode === 'view' ?
                    <LabelValueCard md={12} label='Description' value={notes.description && notes.description.length > 200 ? (
                      <div>
                        {this.state.showFullText.description ? (
                          <span>
                            <span dangerouslySetInnerHTML={{ __html: notes.description?.replace(/\n/g, '<br />') }} />
                            <a href="#" style={{ color: '#0E7FE1', fontSize: '14px', marginLeft: 5 }} onClick={(e) => { e.preventDefault(); this.toggleTextExpand('description'); }}> less </a>
                          </span>
                        ) : (
                          <span>
                            <span dangerouslySetInnerHTML={{ __html: notes.description.substring(0, 190)?.replace(/\n/g, '<br />') }} />
                            <a href="#" style={{ color: '#0E7FE1', fontSize: '14px', marginLeft: 5 }} onClick={(e) => { e.preventDefault(); this.toggleTextExpand('description'); }}> ..more </a>
                          </span>
                        )}
                      </div>
                    ) : (
                      <div>{notes.description !== '--' ? <span dangerouslySetInnerHTML={{ __html: notes.description?.replace(/\n/g, '<br />') }} /> : '--'}</div>
                    )} /> :
                    <Grid item xs={12}>
                      <TextField
                        required
                        id="description"
                        label="Description"
                        fullWidth
                        margin="normal"
                        value={notes.description ? notes.description : ''}
                        InputLabelProps={{ shrink: true }}
                        error={error.description ? true : false}
                        multiline
                        rows={3}
                        helperText={error.description ? error.description : ''}
                        onChange={(e) => this.onFieldChange(e, 'description', e.target.value)}
                        onFocus={(e) => this.updateErrorField('description', '')}
                      />
                    </Grid>
                  }
                  {mode === 'view' ?
                    <LabelValueCard md={12} label='Description' value={notes.remarks && notes.remarks.length > 200 ? (
                      <div>
                        {this.state.showFullText.remarks ? (
                          <span>
                            <span dangerouslySetInnerHTML={{ __html: notes.remarks?.replace(/\n/g, '<br />') }} />
                            <a href="#" style={{ color: '#0E7FE1', fontSize: '14px', marginLeft: 5 }} onClick={(e) => { e.preventDefault(); this.toggleTextExpand('remarks'); }}> less </a>
                          </span>
                        ) : (
                          <span>
                            <span dangerouslySetInnerHTML={{ __html: notes.remarks.substring(0, 190)?.replace(/\n/g, '<br />') }} />
                            <a href="#" style={{ color: '#0E7FE1', fontSize: '14px', marginLeft: 5 }} onClick={(e) => { e.preventDefault(); this.toggleTextExpand('remarks'); }}> ..more </a>
                          </span>
                        )}
                      </div>
                    ) : (
                      <div>{notes.remarks !== '--' ? <span dangerouslySetInnerHTML={{ __html: notes.remarks?.replace(/\n/g, '<br />') }} /> : '--'}</div>
                    )} /> :
                    <Grid item xs={12}>
                      <TextField
                        id="remarks"
                        label="Details"
                        fullWidth
                        margin="normal"
                        multiline
                        rows={3}
                        value={notes.remarks ? notes.remarks : ''}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => this.onFieldChange(e, 'remarks', e.target.value)}
                      />
                    </Grid>
                  }
                  {mode === 'view' ?
                    <LabelValueCard md={6} label='Start Date' value={notes.start_date ? moment(notes.start_date).format(displayDateFormatShort) : '--'} /> :
                    <Grid item xs={12} md={6}>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                          margin="normal"
                          id="start_date"
                          label="Start Date"
                          format={fieldDateFormat}
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          clearable={true}
                          value={notes.start_date ? moment(notes.start_date) : null}
                          onChange={(data, value) => { this.onFieldChange(value, 'start_date', moment(data).format(backendDateFormat)); this.updateErrorField('start_date', '') }}
                          error={error.start_date ? true : false}
                          helperText={error.start_date ? error.start_date : ''}
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                  }

                  {mode === 'view' ?
                    <LabelValueCard md={6} label='End Date' value={notes.end_date ? moment(notes.end_date).format(displayDateFormatShort) : '--'} /> :
                    <Grid item xs={12} md={6}>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                          margin="normal"
                          id="end_date"
                          label="End Date"
                          format={fieldDateFormat}
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          clearable={true}
                          value={notes.end_date ? moment(notes.end_date) : null}
                          onChange={(data, value) => this.onFieldChange(value, 'end_date', moment(data).format(backendDateFormat))}
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                  }
                </Grid>
              </div>
              <div className="drawer-footer">
                {mode !== 'view' ?
                  <Button onClick={this.addEditNotesFn} color="primary" variant="contained" disabled={formSubmitLoader}>
                    {formSubmitLoader ? <CircularProgress color="#ffffff" size={24} /> : 'Save Changes'}
                  </Button> : null
                }
                <Button onClick={() => this.setState({ modal: false, mode: '', notes: {}, error: {} })} color="primary" style={mode == 'view' ? { marginLeft: 'auto', paddingLeft: '0px' } : { marginLeft: '8px' }}>Cancel</Button>
              </div>
            </div>
          </Drawer> : null
        }
      </Fragment>
    )
  }
}
export default withRouter(withSnackbar(NotesCRU));
